module.exports = __webpack_public_path__ + "static/media/img_offer_alarms.be424b22.png";